var map = {
	"./about.svg": [
		63757
	],
	"./apply_champion.svg": [
		37087
	],
	"./appstatus.svg": [
		75939,
		5939
	],
	"./arrow.svg": [
		55122,
		5122
	],
	"./bsc-icon.svg": [
		45106,
		5106
	],
	"./calendar.svg": [
		2202,
		2202
	],
	"./champion_login.svg": [
		78146
	],
	"./champion_signup.svg": [
		79678
	],
	"./copy.svg": [
		28271,
		8271
	],
	"./ethereum-icon.svg": [
		41531,
		1531
	],
	"./facebook.svg": [
		57088,
		7088
	],
	"./help.svg": [
		3452
	],
	"./info-icon.svg": [
		2388
	],
	"./legal.svg": [
		54280
	],
	"./light-arrow.svg": [
		90830,
		830
	],
	"./light-discord.svg": [
		31033,
		1033
	],
	"./light-telegram.svg": [
		45079,
		5079
	],
	"./light-twitter.svg": [
		12972,
		2972
	],
	"./light-website.svg": [
		4088,
		4088
	],
	"./logout.svg": [
		79175
	],
	"./mail-300.svg": [
		61401,
		1401
	],
	"./mail.svg": [
		84765,
		4765
	],
	"./metamask1.svg": [
		6352
	],
	"./profile.svg": [
		49829
	],
	"./security.svg": [
		19125,
		9125
	],
	"./show-more.svg": [
		10618,
		618
	],
	"./telegram.svg": [
		18571
	],
	"./twitter.svg": [
		20794
	],
	"./youtube.svg": [
		77716
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 68605;
module.exports = webpackAsyncContext;